<div class="table-responsive table-scroll-small">
  <table class="table table-bordered table-sm table-striped">
    <thead>
    <tr>
      <th scope="col" (click)="setOrder('timestamp')">{{ 'colTimestamp' | translate }}
        <i class="fa" [ngClass]="getClass('timestamp')"></i>
        </th>

      <th scope="col" (click)="setOrder('sixLetterCode')">{{ 'colInstrument' | translate }}
        <i class="fa" [ngClass]="getClass('sixLetterCode')"></i>
      </th>

      <th scope="col" (click)="setOrder('swap')">{{ 'colSwap' | translate }}
        <i class="fa" [ngClass]="getClass('swap')"></i>
      </th>

      <th scope="col" (click)="setOrder('quantity')">{{ 'colQty' | translate }}
        <i class="fa" [ngClass]="getClass('quantity')"></i>
      </th>

      <th scope="col" (click)="setOrder('direction')">{{ 'colBorrow' | translate }} / {{ 'colLend' | translate }}
        <i class="fa" [ngClass]="getClass('direction')"></i>
      </th>

      <th scope="col" (click)="setOrder('price')">{{ 'colPrice' | translate }}
        <i class="fa" [ngClass]="getClass('price')"></i>
      </th>

      <th scope="col" (click)="setOrder('rate')">{{ 'colRate' | translate }}
        <i class="fa" [ngClass]="getClass('rate')"></i>
      </th>
    </tr>
    </thead>

    <tbody *ngIf="!SwapHistoryColumns || !SwapHistoryColumns.length || SwapHistoryColumns.length < 1 || (SwapHistoryColumns | dateRangeFilter:bsRangeValue[0]:bsRangeValue[1]).length == 0">
    <tr *ngFor="let i of Arr(num).fill(1)"><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
    </tbody>

    <tbody *ngIf="SwapHistoryColumns && SwapHistoryColumns.length">
    <ng-container *ngFor="let column of SwapHistoryColumns | dateRangeFilter:bsRangeValue[0]:bsRangeValue[1] | multiOrder: order, let i = index">
      <tr id="{{'SWAP_HISTORY_ROW_' + i}}">

        <td class="text-center" *ngIf="(column.timestamp | date:'yyyy') === (today | date: 'yyyy')">
          {{column.timestamp | date:'dd MMM - HH:mm:ss'}}
        </td>

        <td class="text-center" *ngIf="(column.timestamp | date:'yyyy') !== (today | date: 'yyyy')">
          {{column.timestamp | date:'dd MMM yyyy - HH:mm:ss'}}
        </td>

        <td class="text-center">{{currencyPairsJson[column.sixLetterCode].instrument.name}}</td>
        <td class="text-center">{{column.swap}}</td>
        <td class="text-right">{{column.quantity | number:'1.2-2'}}</td>
        <td class="text-center">{{column.direction}}</td>
        <td>{{column.price | priceFactorPipe: column.sixLetterCode | number:'1.0'}}</td>
        <td>{{column.rate}}%</td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</div><!-- responsive table END -->

<div class="d-flex justify-content-between align-items-center">

  <div class="form-group">
  <div class="input-group">
    <div class="input-group-prepend">
      <div class="input-group-text" (click)="drp.toggle()" [attr.aria-expanded]="drp.isOpen"><i class="fa fa-calendar" aria-hidden="true"></i></div>
    </div>
    <input type="text"
           class="form-control
           form-control-sm"
           #drp="bsDaterangepicker"
           bsDaterangepicker
           [(ngModel)]="bsRangeValue"
           [minDate]="minDate"
           [maxDate]="maxDate"
           [bsConfig]="{ adaptivePosition: true, showWeekNumbers: false }"
    >
  </div>
  </div>


  <button type="button" class="btn btn-sm btn-primary"><i class="fa fa-files-o" aria-hidden="true"></i> Copy to clipboard</button>

</div>
